import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GametypeService } from '../../services/gametype.service';
import { Gametype } from '../../services/data.service';
import { DeviceDetectService } from '../../services/device-detect.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements OnInit {
  topGametype$: Observable<Gametype | null>;
  isMobile: boolean = false;

  constructor(
    private gametypeService: GametypeService,
    private deviceDetectService: DeviceDetectService
  ) {
    this.topGametype$ = this.gametypeService.getTopGametype();
  }

  ngOnInit(): void {
    this.isMobile = this.deviceDetectService.getIsMobile();
  }
}

